import React, {useEffect} from 'react';

import {observer} from 'mobx-react';
import {StandAloneWidgetWrapper} from "../../components/standalone-widget-wrapper/standalone-widget-wrapper";

export const AppModuleContentWidgetsStandAlone = observer(({
                                                             controller,
                                                             onWidgetVisible,
                                                             handleRouterLoaded
                                                           }) => {
  useEffect(() => {
    handleRouterLoaded();
  }, [handleRouterLoaded]);

  return (
    <StandAloneWidgetWrapper controller={controller} onWidgetVisible={onWidgetVisible}/>
  );
});
